import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { noUrlValidator } from 'app/core/form-validators';

@Directive({
  selector: '[noUrlValidator]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NoUrlValidatorDirective),
      multi: true,
    },
  ],
})
export class NoUrlValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return noUrlValidator()(control);
  }
}
